var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('fullscreen',{ref:"fullscreen",on:{"change":_vm.fullscreenChange}},[_vm._v("\n    Content\n  ")]),_c('button',{attrs:{"type":"button"},on:{"click":_vm.toggle}},[_vm._v("Fullscreen")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }